import * as React from 'react';
import {useDispatch} from 'react-redux';
import LogoutIcon from '@mui/icons-material/Logout';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import {AppDispatch} from '../../redux/store';
import {logout} from '../../redux/slices/authSlice';

const LogOut = () => {
  const dispatch = useDispatch<AppDispatch>();
  const handleLogOut = () => {
    void dispatch(logout());
  };

  return (
    <Tooltip title="Log Out" placement="left">
      <Box onClick={handleLogOut} onKeyDown={handleLogOut}>
        <LogoutIcon />
      </Box>
    </Tooltip>
  );
};

export default LogOut;
